import { useMemo } from "react";
import { currentDateTime, decimalToTime, formatDateTime } from "utils/formatter";
import { markingByCell, markingDurationCell, markingEndDateCell, markingStartDateCell, statusTypeCell } from "./useColumns";
import { tableHooks } from "components/Table";

const useColumns = () => {
    const playCell = tableHooks.usePlayCell()

    const columns = useMemo(
        () => [
            {
                accessorKey: "version",
                header: "מספר גרסא"
            },
            {
                accessorKey: 'marking_words_update_by',
                header: 'סומן ע"י',
            },
            {
                accessorKey: 'marking_words_version_duration',
                header: "משך סימון",
                cell: info => decimalToTime(info.getValue()),
            },
            {
                accessorKey: 'marking_words_version_start_date',
                header: " התחלת סימון",
                cell: info => info.getValue() ? `${formatDateTime(info.getValue()) || ""}` : "",
            },
            markingEndDateCell,
            statusTypeCell,
            playCell
        ], []
    )

    return columns
}

export default useColumns